<div *ngIf="calendarType == 'from'; else toCalendar">
  <p-calendar
    #primeCalendar
    dataType="string"
    [(ngModel)]="queryModel.fromDate"
    (onShow)="setMinMaxDate()"
    [maxDate]="maxFromDate"
    inputId="icon"
    appendTo="body"
    dateFormat="yy-mm-dd"
    placeholder="Select From Date"
  >
    <ng-template pTemplate="footer">
      <div class="border-top p-2">
        <button
          type="button"
          (click)="setDay()"
          class="p-ripple p-element p-button-text p-button p-component inline-block"
        >
          Today
        </button>
        <button
          type="button"
          (click)="setDays(6)"
          class="p-ripple p-element p-button-text p-button p-component inline-block"
        >
          Last 7 days
        </button>
        <button
          type="button"
          (click)="setDays(14)"
          class="p-ripple p-element p-button-text p-button p-component inline-block"
        >
          Last 15 days
        </button>
        <button
          type="button"
          (click)="setDays(29)"
          class="p-ripple p-element p-button-text p-button p-component inline-block"
        >
          Last 30 days
        </button>
        <button
          *ngIf="showReset"
          type="button"
          (click)="reset()"
          class="btn btn-md btn-primary inline-block"
        >
          Reset
        </button>
      </div>
      
    </ng-template>
  </p-calendar>
  <!-- <div class="warning-message" *ngIf="!queryModel.fromDate && queryModel.toDate">
    From Date is required when To Date is selected.
  </div> -->
</div>

<ng-template #toCalendar>
  <p-calendar
    #primeCalendar
    dataType="string"
    [(ngModel)]="queryModel.toDate"
    (onShow)="setMinMaxDate()"
    [maxDate]="maxToDate"
    [minDate]="minToDate"
    inputId="icon"
    dateFormat="yy-mm-dd"
    appendTo="body"
    placeholder="Select To Date"
  >
    <ng-template pTemplate="footer">
      <div class="border-top p-2">
        <button
          type="button"
          (click)="setDay()"
          class="p-ripple p-element p-button-text p-button p-component"
        >
          Today
        </button>
        <button
          type="button"
          (click)="setDays(6)"
          class="p-ripple p-element p-button-text p-button p-component"
        >
          Last 7 days
        </button>
        <button
          type="button"
          (click)="setDays(14)"
          class="p-ripple p-element p-button-text p-button p-component"
        >
          Last 15 days
        </button>
        <button
          type="button"
          (click)="setDays(29)"
          class="p-ripple p-element p-button-text p-button p-component"
        >
          Last 30 days
        </button>
        <button *ngIf="showReset" type="button" (click)="reset()" class="btn btn-md btn-primary">
          Reset
        </button>
      </div>
    </ng-template>
  </p-calendar>
  <!-- <div class="warning-message" *ngIf="queryModel.fromDate && !queryModel.toDate">
    To Date is required when From Date is selected.
  </div> -->
</ng-template>
